const CollectionFilterSpKeywords = (el, onChangeFilterParams, onClose) => {


  let filterParams = []


  const initialize = () => {
    el.querySelector('form').addEventListener('submit', e => {
      e.preventDefault()
      el.querySelector('input').blur()
    })

    el.querySelector('input').addEventListener('input', e => {
      const newFilterParams = filterParams.filter(kv => kv.key != e.target.name)
      if (!e.target.value || e.target.value.length <= 0) {
        onChangeFilterParams(newFilterParams)
      } else {
        onChangeFilterParams([...newFilterParams, {key: e.target.name, value: e.target.value}])
      }
    })
  }


  const setFilterParams = (newFilterParams) => {
    filterParams = newFilterParams

    const input = el.querySelector('input')
    if (input) {
      input.value = filterParams?.find(kv => kv.key == input.name)?.value ?? null
    }
  }


  initialize()

  return {
    setFilterParams: setFilterParams
  }
}


export default CollectionFilterSpKeywords
